import * as React from "react";
import { MediaQuery } from "react-responsive";
import { isScrollDisabled } from "../helpers/helper/index.mjs";
import { ThemeContext } from "../helpers/theme-provider/theme-provider.mjs";
import { DesktopComparison } from "./desktop.mjs";
import { MobileComparison } from "./mobile.mjs";
import debounce from "debounce";
const _ProductComparison = class _ProductComparison extends React.Component {
  constructor(props) {
    super(props);
    this.headerRef = React.createRef();
    this.onCompareCheckChange = (value) => {
      if (value !== this.state.isCompareChecked) {
        this.setState({
          isCompareChecked: value
        });
      }
      if (this.props.onCompareCheckChange) {
        this.props.onCompareCheckChange(value);
      }
    };
    this.handleScroll = () => {
      if (!isScrollDisabled()) {
        const scrollTop = window.pageYOffset;
        const offset = this.getScrolledOffset();
        if (scrollTop > offset && !this.state.hasScrolled) {
          this.setState({
            hasScrolled: true
          });
        } else if (scrollTop < offset && this.state.hasScrolled) {
          this.setState({
            hasScrolled: false
          });
        }
      }
    };
    this.state = {
      isCompareChecked: false,
      isMounted: false,
      hasScrolled: false
    };
    this.debouncedScrollHandler = debounce(this.handleScroll, 50);
  }
  componentDidMount() {
    this.setState({
      isMounted: true
    });
    window.addEventListener("scroll", this.debouncedScrollHandler);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.debouncedScrollHandler);
    this.debouncedScrollHandler.clear();
  }
  BEM() {
    const classArray = ["product-comparison"];
    if (this.state.hasScrolled) {
      classArray.push("has-scrolled");
    }
    if (this.state.isCompareChecked) {
      classArray.push("show-difference");
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  getScrolledOffset() {
    const ref = this.headerRef.current;
    if (ref) {
      return ref.clientHeight + ref.offsetTop;
    }
    return 450;
  }
  renderDesktopLayout() {
    return /* @__PURE__ */ React.createElement(DesktopComparison, { ...this.props, isCompareChecked: this.state.isCompareChecked, onCompareCheckChange: this.onCompareCheckChange });
  }
  renderMobileLayout() {
    return /* @__PURE__ */ React.createElement(
      MobileComparison,
      {
        ...this.props,
        isCompareChecked: this.state.isCompareChecked,
        onCompareCheckChange: this.onCompareCheckChange,
        headerRef: this.headerRef,
        hasScrolled: this.state.hasScrolled
      }
    );
  }
  renderDynamicLayout() {
    return /* @__PURE__ */ React.createElement(MediaQuery, { maxWidth: this.context.media.width.md.max }, (matches) => matches ? this.renderMobileLayout() : this.renderDesktopLayout());
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: this.BEM() }, this.state.isMounted ? this.renderDynamicLayout() : this.renderDesktopLayout());
  }
};
_ProductComparison.contextType = ThemeContext;
let ProductComparison = _ProductComparison;
export {
  ProductComparison
};
